export const projectsDragHandler = (e, handler) => {
    const isProjectArchived = () => {
        if(!e.nativeEvent) return;

        const { clientX, clientY } = e.nativeEvent;

        const element = document.elementFromPoint(clientX, clientY);

        if(!element) return;

        if(element.closest('div#archiveZone')) return true;
        else return false;
    }

    let newStatus = '';

    const isArchived = isProjectArchived();


    if(isArchived) newStatus = 'Archived';
    else if(e.operation.target)
    {
        if (/inactive$/.test(e.operation.target.id)) newStatus = 'Inactive';
        else if (/active$/.test(e.operation.target.id)) newStatus = 'Active';
        else if (/finished$/.test(e.operation.target.id)) newStatus = 'Finished';
        else return;
    }
    else return;

    return (handler?.({
        projectUuid: e.operation.source.id,
        action: "STATUS CHANGE",
        changes: { newStatus: newStatus}
    }));
}

export const tasksDragHandler = (e, handler) => {
    const isTaskArchived = () => {
        if(!e.nativeEvent) return;

        const { clientX, clientY } = e.nativeEvent;

        const element = document.elementFromPoint(clientX, clientY);

        if(!element) return;

        if(element.closest('div#archiveZone')) return true;
        else return false;
    }

    let newStatus = '';
    const isArchived = isTaskArchived();

    if(isArchived)
    {
        newStatus = 'Archived';
    }
    else if(e.operation.target)
    {
        if (/not-started/.test(e.operation.target.id)) newStatus = 'NotStarted';
        else if (/started/.test(e.operation.target.id)) newStatus = 'Started';
        else if (/stopped/.test(e.operation.target.id)) newStatus = 'Stopped';
        else if (/finished/.test(e.operation.target.id)) newStatus = 'Finished';
        else return;
    }
    else return;

    return(handler?.({
        taskUuid: e.operation.source.id,
        action: "STATUS CHANGE",
        changes: { newStatus: newStatus}
    }));
}